import { categories } from './conversionData.js';

export const CATEGORY_MAP = {
  'common': 'common',
  'engineering': 'engineering',
  'heat': 'heat',
  'fluids': 'fluids',
  'light': 'light',
  'electricity': 'electricity',
  'magnetism': 'magnetism',
  'radiology': 'radiology',
  'other': 'other',
  'currency': 'currency'
};

export const CONVERTER_MAP = {
  'length': 'length',
  'temperature': 'temperature',
  'weight': 'weight',
  'volume': 'volume',
  'area': 'area',
  'time': 'time',
  'speed': 'speed',
  'shoe-size': 'shoeSize',
  'moeda': 'currency',
  'consumo-combustivel': 'fuelConsumption',
  'culinaria': 'cooking',
  'ritmo': 'pace',
  'density': 'density',
  'vel_angular': 'angularVelocity',
  'aceleracao': 'acceleration',
  'aceleracao-angular': 'angularAcceleration',
  'volume-especifico': 'specificVolume',
  'momento-inercia': 'momentOfInertia',
  'torque': 'torque',
  'pressure': 'pressure',
  'energy': 'energy',
  'angulo': 'angle',
  'potencia': 'power',
  'forca': 'force',
  'frequencia': 'frequency',
  'nivel-som': 'sound-level',
  'tamanho-camiseta': 'clothing-size-shirt',
  'tamanho-calca': 'clothing-size-pants',
  'tamanho-tenis': 'clothing-size-shoes',
  'fuel-efficiency-mass': 'fuelEfficiency',
  'fuel-efficiency-volume': 'fuelEfficiency',
  'temperature-interval': 'temperatureInterval',
  'thermal-expansion': 'thermalExpansion',
  'thermal-resistance': 'thermalResistance',
  'thermal-conductivity': 'thermalConductivity',
  'specific-heat-capacity': 'specificHeatCapacity',
  'thermal-energy-density': 'thermalEnergyDensity',
  'heat-flux-density': 'heatFluxDensity',
  'heat-transfer-coefficient': 'heatTransferCoefficient',
  'volumetric-flow-rate': 'volumetricFlow',
  'mass-flow-rate': 'massFlow',
  'molar-flow-rate': 'molarFlow',
  'mass-flux-density': 'massFluxDensity',
  'molar-concentration': 'molarConcentration',
  'solution-concentration': 'solutionConcentration',
  'dynamic-viscosity': 'dynamicViscosity',
  'kinematic-viscosity': 'kinematicViscosity',
  'surface-tension': 'surfaceTension',
  'permeability': 'permeability',
  'luminance': 'luminance',
  'luminous-intensity': 'luminousIntensity',
  'illumination': 'illumination',
  'digital-image-resolution': 'digitalImageResolution',
  'frequency-wavelength': 'frequency',
  'charge': 'charge',
  'current': 'current',
  'voltage': 'voltage',
  'linear-charge-density': 'linearChargeDensity',
  'surface-charge-density': 'surfaceChargeDensity',
  'volume-charge-density': 'volumeChargeDensity',
  'linear-current-density': 'linearCurrentDensity',
  'surface-current-density': 'surfaceCurrentDensity',
  'electric-field-strength': 'electricFieldStrength',
  'electrical-resistance': 'resistance',
  'electrical-resistivity': 'electricalResistivity',
  'electrical-conductance': 'conductance',
  'electrical-conductivity': 'electricalConductivity',
  'electrostatic-capacitance': 'capacitance',
  'inductance': 'inductance',
  'magnetomotive-force': 'magnetomotiveForce',
  'magnetic-field-intensity': 'magneticFieldIntensity',
  'magnetic-flux': 'magneticFlux',
  'magnetic-flux-density': 'magneticFluxDensity',
  'radiacao': 'radiation',
  'atividade-radiacao': 'radiationActivity',
  'exposicao-radiacao': 'radiationExposure',
  'dose-absorvida': 'absorbedDose',
  'data_storage': 'dataStorage',
  'data_transfer': 'dataTransfer',
  'typography': 'typography',
  'ppm': 'ppm',
  'potencia-dbm': 'powerDbm',
  'escala': 'scale',
  'numeros-grandes': 'largeNumbers',
  'culinaria-gramas': 'cupToGrams',
  'bases-numericas': 'numberBases',
  'pixels-dpi': 'pixelsDpi',
  'fracao-polegada': 'inchFraction',
  'cores': 'colorConverter',
  'fuso-horario': 'timezone'
};

const UNIT_EN = {
  // Length
  'Quilômetro': 'Kilometer',
  'Metro': 'Meter',
  'Centímetro': 'Centimeter',
  'Milímetro': 'Millimeter',
  'Micrômetro': 'Micrometer',
  'Nanômetro': 'Nanometer',
  'Milha': 'Mile',
  'Jarda': 'Yard',
  'Pé': 'Foot',
  'Polegada': 'Inch',
  'Ano-luz': 'Light Year',
  'Milha Náutica': 'Nautical Mile',
  'Légua': 'Légua (Brazilian League)',
  'Braça': 'Braça (Brazilian Fathom)',
  'Vara': 'Vara (Brazilian Yard)',

  // Area
  'Quilômetro Quadrado': 'Square Kilometer',
  'Metro Quadrado': 'Square Meter',
  'Milha Quadrada': 'Square Mile',
  'Jarda Quadrada': 'Square Yard',
  'Pé Quadrado': 'Square Foot',
  'Polegada Quadrada': 'Square Inch',
  'Hectare': 'Hectare',
  'Acre': 'Acre',
  'Alqueire Paulista': 'Alqueire Paulista (Brazilian Land Unit)',

  // Volume
  'Metro Cúbico': 'Cubic Meter',
  'Litro': 'Liter',
  'Mililitro': 'Milliliter',
  'Galão (EUA)': 'Gallon (US)',
  'Quartilho (EUA)': 'Quart (US)',
  'Pinto (EUA)': 'Pint (US)',
  'Xícara (EUA)': 'Cup (US)',
  'Onça Fluida (EUA)': 'Fluid Ounce (US)',
  'Colher de Sopa (EUA)': 'Tablespoon (US)',
  'Colher de Chá (EUA)': 'Teaspoon (US)',
  'Galão (Imperial)': 'Gallon (Imperial)',
  'Pé Cúbico': 'Cubic Foot',
  'Polegada Cúbica': 'Cubic Inch',

  // Weight/Mass
  'Quilograma': 'Kilogram',
  'Grama': 'Gram',
  'Miligrama': 'Milligram',
  'Tonelada Métrica': 'Metric Ton',
  'Libra': 'Pound',
  'Onça': 'Ounce',
  'Arroba': 'Arroba (Brazilian Cattle Unit)',
  'Quilate': 'Carat',
  'Tonelada Longa (UK)': 'Long Ton (UK)',
  'Tonelada Curta (US)': 'Short Ton (US)',
  'Pedra (UK)': 'Stone (UK)',

  // Temperature
  'Grau Celsius': 'Degree Celsius',
  'Grau Fahrenheit': 'Degree Fahrenheit',
  'Kelvin': 'Kelvin',
  'Grau Rankine': 'Degree Rankine',

  // Time
  'Segundo': 'Second',
  'Minuto': 'Minute',
  'Hora': 'Hour',
  'Dia': 'Day',
  'Semana': 'Week',
  'Mês': 'Month',
  'Ano': 'Year',
  'Milissegundo': 'Millisecond',
  'Microssegundo': 'Microsecond',
  'Nanossegundo': 'Nanosecond',
  'Década': 'Decade',
  'Século': 'Century',

  // Speed
  'Metros por Segundo': 'Meters per Second',
  'Quilômetros por Hora': 'Kilometers per Hour',
  'Milhas por Hora': 'Miles per Hour',
  'Pés por Segundo': 'Feet per Second',
  'Nó': 'Knot',

  // Pressure
  'Pascal': 'Pascal',
  'Quilopascal': 'Kilopascal',
  'Bar': 'Bar',
  'Atmosfera Padrão': 'Standard Atmosphere',
  'Torr': 'Torr',
  'Libra por Polegada Quadrada (psi)': 'Pounds per Square Inch (psi)',

  // Energy
  'Joule': 'Joule',
  'Quilojoule': 'Kilojoule',
  'Caloria': 'Calorie',
  'Quilocaloria': 'Kilocalorie',
  'Watt-hora': 'Watt-hour',
  'Quilowatt-hora': 'Kilowatt-hour',
  'Elétron-volt': 'Electronvolt',
  'BTU': 'BTU',

  // Power
  'Watt': 'Watt',
  'Quilowatt': 'Kilowatt',
  'Megawatt': 'Megawatt',
  'Gigawatt': 'Gigawatt',
  'Cavalo-vapor (hp)': 'Horsepower (hp)',

  // Force
  'Newton': 'Newton',
  'Quilonewton': 'Kilonewton',
  'Libra-força': 'Pound-force',
  'Dina': 'Dyne',

  // Data
  'Bit': 'Bit',
  'Byte': 'Byte',
  'Kilobyte': 'Kilobyte',
  'Megabyte': 'Megabyte',
  'Gigabyte': 'Gigabyte',
  'Terabyte': 'Terabyte',
  'Petabyte': 'Petabyte',
  'Exabyte': 'Exabyte',
  'Zettabyte': 'Zettabyte',
  'Yottabyte': 'Yottabyte',

  // Unidades internacionais — nome idêntico em português e inglês (não traduzir)
  'Celsius': 'Celsius',
  'Fahrenheit': 'Fahrenheit',
  'Kelvin': 'Kelvin',
  'Hectare': 'Hectare',
  'Acre': 'Acre',
  'kg/m³': 'kg/m³',
  'g/cm³': 'g/cm³',
  'Galileo': 'Galileo',
  'Pascal': 'Pascal',
  'Bar': 'Bar',
  'Joule': 'Joule',
  'Centipoise': 'Centipoise',
  'Poise': 'Poise',
  'Stokes': 'Stokes',
  'Centistokes': 'Centistokes',
  'Darcy': 'Darcy',
  'Barn': 'Barn',
  'Foot-lambert': 'Foot-lambert',
  'Lambert': 'Lambert',
  'Nit': 'Nit',
  'Candela': 'Candela',
  'Candlepower': 'Candlepower',
  'Lux': 'Lux',
  'Foot-candle': 'Foot-candle',
  'Hertz': 'Hertz',
  'Megahertz': 'Megahertz',
  'Gigahertz': 'Gigahertz',
  'Terahertz': 'Terahertz',
  'Coulomb': 'Coulomb',
  'Ampere': 'Ampere',
  'Volt': 'Volt',
  'Microvolt': 'Microvolt',
  'Nanovolt': 'Nanovolt',
  'Megavolt': 'Megavolt',
  'Gigavolt': 'Gigavolt',
  'Abvolt': 'Abvolt',
  'Ohm': 'Ohm',
  'Microohm': 'Microohm',
  'Megaohm': 'Megaohm',
  'Gigaohm': 'Gigaohm',
  'Siemens': 'Siemens',
  'Microsiemens': 'Microsiemens',
  'Nanosiemens': 'Nanosiemens',
  'Mho': 'Mho',
  'Micromho': 'Micromho',
  'Farad': 'Farad',
  'Microfarad': 'Microfarad',
  'Nanofarad': 'Nanofarad',
  'Picofarad': 'Picofarad',
  'Abfarad': 'Abfarad',
  'Henry': 'Henry',
  'Microhenry': 'Microhenry',
  'Nanohenry': 'Nanohenry',
  'Picohenry': 'Picohenry',
  'Abhenry': 'Abhenry',
  'Oersted': 'Oersted',
  'Gilbert': 'Gilbert',
  'Weber': 'Weber',
  'Microweber': 'Microweber',
  'Maxwell': 'Maxwell',
  'Tesla': 'Tesla',
  'Microtesla': 'Microtesla',
  'Nanotesla': 'Nanotesla',
  'Gauss': 'Gauss',
  'Becquerel': 'Becquerel',
  'Curie': 'Curie',
  'Rutherford': 'Rutherford',
  'Megabecquerel': 'Megabecquerel',
  'Gigabecquerel': 'Gigabecquerel',
  'Terabecquerel': 'Terabecquerel',
  'Microcurie': 'Microcurie',
  'Nanocurie': 'Nanocurie',
  'Roentgen': 'Roentgen',
  'Microroentgen': 'Microroentgen',
  'Gray': 'Gray',
  'Microgray': 'Microgray',
  'Rad': 'Rad',
  'Byte': 'Byte',
  'Kilobyte': 'Kilobyte',
  'Megabyte': 'Megabyte',
  'Gigabyte': 'Gigabyte',
  'Terabyte': 'Terabyte',
  'Pixel': 'Pixel',
  'Em': 'Em',
  'Rem': 'Rem',

  // Angle
  'Grau': 'Degree',
  'Radiano': 'Radian',
  'Grado': 'Gradian',
  'Minuto de Arco': 'Arcminute',
  'Segundo de Arco': 'Arcsecond',
  'Volta Completa': 'Full Turn',

  // Power
  'Watt': 'Watt',
  'Miliwatt': 'Milliwatt',
  'Quilowatt': 'Kilowatt',
  'Megawatt': 'Megawatt',
  'Cavalo-vapor': 'Metric Horsepower',
  'Horsepower': 'Horsepower',
  'BTU por Hora': 'BTU per Hour',

  // Force
  'Newton': 'Newton',
  'Quilonewton': 'Kilonewton',
  'Dina': 'Dyne',
  'Libra-força': 'Pound-force',
  'Quilograma-força': 'Kilogram-force',
  'Tonelada-força': 'Ton-force',

  // Frequency / Sound Level / Clothing Size
  'Rotações por Minuto': 'Revolutions per Minute',
  'Decibel': 'Decibel',
  'Bel': 'Bel',
  'Neper': 'Neper',

  // Advanced / Engineering Units
  'Radianos por Segundo': 'Radians per Second',
  'Graus por Segundo': 'Degrees per Second',
  'Rotações por Minuto (RPM)': 'Revolutions per Minute (RPM)',
  'Metros por Segundo ao Quadrado': 'Meters per Second Squared',
  'Gal': 'Gal',
  'Radianos por Segundo ao Quadrado': 'Radians per Second Squared',
  'Metro Cúbico por Quilograma': 'Cubic Meter per Kilogram',
  'Quilograma Metro Quadrado': 'Kilogram Square Meter',
  'Newton Metro': 'Newton Meter',
  'Libra-pé': 'Pound-foot',
  'Quilômetros por Litro': 'Kilometers per Liter',
  'Milhas por Galão (US)': 'Miles per Gallon (US)',
  'Milhas por Galão (UK)': 'Miles per Gallon (UK)',
  'Watt por Metro Kelvin': 'Watt per Meter Kelvin',
  'Joule por Quilograma Kelvin': 'Joule per Kilogram Kelvin',
  'Joule por Metro Cúbico': 'Joule per Cubic Meter',
  'Watt por Metro Quadrado': 'Watt per Square Meter',
  'Watt por Metro Quadrado Kelvin': 'Watt per Square Meter Kelvin',
  'Metro Cúbico por Segundo': 'Cubic Meter per Second',
  'Litros por Minuto': 'Liters per Minute',
  'Quilogramas por Segundo': 'Kilograms per Second',
  'Mol por Segundo': 'Moles per Second',
  'Quilograma por Metro Quadrado Segundo': 'Kilograms per Square Meter Second',
  'Mol por Metro Cúbico': 'Moles per Cubic Meter',
  'Quilograma por Metro Cúbico': 'Kilograms per Cubic Meter',
  'Pascal Segundo': 'Pascal Second',
  'Poise': 'Poise',
  'Metro Quadrado por Segundo': 'Square Meter per Second',
  'Stokes': 'Stokes',
  'Newton por Metro': 'Newton per Meter',
  'Henry por Metro': 'Henry per Meter',
  'Candela por Metro Quadrado': 'Candela per Square Meter',
  'Candela': 'Candela',
  'Lux': 'Lux',
  'Foot-candle': 'Foot-candle',
  'Pixels por Polegada (PPI)': 'Pixels per Inch (PPI)',
  'Hertz': 'Hertz',
  'Quilohertz': 'Kilohertz',
  'Megahertz': 'Megahertz',
  'Gigahertz': 'Gigahertz',

  // Electricity & Magnetism
  'Coulomb': 'Coulomb',
  'Mili-ampere-hora': 'Milliampere-hour',
  'Ampere-hora': 'Ampere-hour',
  'Ampere': 'Ampere',
  'Miliampere': 'Milliampere',
  'Volt': 'Volt',
  'Milivolt': 'Millivolt',
  'Quilovolt': 'Kilovolt',
  'Coulomb por Metro': 'Coulomb per Meter',
  'Coulomb por Metro Quadrado': 'Coulomb per Square Meter',
  'Coulomb por Metro Cúbico': 'Coulomb per Cubic Meter',
  'Ampere por Metro': 'Ampere per Meter',
  'Ampere por Metro Quadrado': 'Ampere per Square Meter',
  'Volt por Metro': 'Volt per Meter',
  'Ohm': 'Ohm',
  'Ohm Metro': 'Ohm Meter',
  'Siemens': 'Siemens',
  'Siemens por Metro': 'Siemens per Meter',
  'Farad': 'Farad',
  'Microfarad': 'Microfarad',
  'Henry': 'Henry',
  'Milihenry': 'Millihenry',
  'Ampere-espira': 'Ampere-turn',
  'Weber': 'Weber',
  'Maxwell': 'Maxwell',
  'Tesla': 'Tesla',
  'Gauss': 'Gauss',

  // Radiology
  'Becquerel': 'Becquerel',
  'Curie': 'Curie',
  'Coulomb por Quilograma': 'Coulomb per Kilogram',
  'Roentgen': 'Roentgen',
  'Gray': 'Gray',
  'Rad': 'Rad',

  // Data Transfer & Typography
  'Bits por Segundo': 'Bits per Second',
  'Bytes por Segundo': 'Bytes per Second',
  'Kilobits por Segundo': 'Kilobits per Second',
  'Kilobytes por Segundo': 'Kilobytes per Second',
  'Megabits por Segundo': 'Megabits per Second',
  'Megabytes por Segundo': 'Megabytes per Second',
  'Ponto': 'Point',
  'Pica': 'Pica',
  'Milímetro (Tipografia)': 'Millimeter (Typography)',
  'Pixel': 'Pixel',
  'Quilograma-força Metro': 'Kilogram-force Meter',

  // Additional units (completeness pass)
  'Celsius': 'Celsius',
  'Fahrenheit': 'Fahrenheit',
  'Galão Americano': 'US Gallon',
  'Metros por segundo': 'Meters per Second',
  'Quilômetros por hora': 'Kilometers per Hour',
  'Milhas por hora': 'Miles per Hour',
  'Nós': 'Knots',
  'Brasil (BR)': 'Brazil (BR)',
  'Estados Unidos (US)': 'United States (US)',
  'Europa (EU)': 'Europe (EU)',
  'Reino Unido (UK)': 'United Kingdom (UK)',
  'Japão (JP)': 'Japan (JP)',
  'kg/m³': 'kg/m³',
  'g/cm³': 'g/cm³',
  'Radiano/segundo': 'Radian/second',
  'Rotações por minuto': 'Revolutions per Minute',
  'Metro por segundo ao quadrado': 'Meter per Second Squared',
  'Quilômetro por hora ao quadrado': 'Kilometer per Hour Squared',
  'Pé por segundo ao quadrado': 'Foot per Second Squared',
  'Galileo': 'Galileo',
  'Polegada por segundo ao quadrado': 'Inch per Second Squared',
  'Radiano por segundo ao quadrado': 'Radian per Second Squared',
  'Grau por segundo ao quadrado': 'Degree per Second Squared',
  'Revolução por segundo ao quadrado': 'Revolution per Second Squared',
  'Grado por segundo ao quadrado': 'Gradian per Second Squared',
  'Metro cúbico por quilograma': 'Cubic Meter per Kilogram',
  'Centímetro cúbico por grama': 'Cubic Centimeter per Gram',
  'Pé cúbico por libra': 'Cubic Foot per Pound',
  'Litro por quilograma': 'Liter per Kilogram',
  'Galão por libra': 'Gallon per Pound',
  'Quilograma metro quadrado': 'Kilogram Square Meter',
  'Grama centímetro quadrado': 'Gram Square Centimeter',
  'Libra pé quadrado': 'Pound Square Foot',
  'Libra polegada quadrada': 'Pound Square Inch',
  'Onça polegada quadrada': 'Ounce Square Inch',
  'Newton metro': 'Newton Meter',
  'Quilonewton metro': 'Kilonewton Meter',
  'Libra-força pé': 'Pound-force Foot',
  'Libra-força polegada': 'Pound-force Inch',
  'Quilograma-força metro': 'Kilogram-force Meter',
  'Dina centímetro': 'Dyne Centimeter',
  'Libra por polegada quadrada': 'Pound per Square Inch',
  'Atmosfera padrão': 'Standard Atmosphere',
  'Quilograma por Megajoule': 'Kilogram per Megajoule',
  'Grama por Joule': 'Gram per Joule',
  'Libra por Milhão de Btu': 'Pound per Million Btu',
  'Libra por Btu': 'Pound per Btu',
  'Litro por Megajoule': 'Liter per Megajoule',
  'Mililitro por Joule': 'Milliliter per Joule',
  'Galão por Milhão de Btu': 'Gallon per Million Btu',
  'Galão por Btu': 'Gallon per Btu',
  'Por Kelvin': 'Per Kelvin',
  'Por Grau Celsius': 'Per Degree Celsius',
  'Por Grau Fahrenheit': 'Per Degree Fahrenheit',
  'Por Grau Rankine': 'Per Degree Rankine',
  'Kelvin por Watt': 'Kelvin per Watt',
  'Grau Celsius por Watt': 'Degree Celsius per Watt',
  'Grau Fahrenheit hora por Btu': 'Degree Fahrenheit Hour per Btu',
  'Kelvin metro por Watt': 'Kelvin Meter per Watt',
  'Watt por metro Kelvin': 'Watt per Meter Kelvin',
  'Watt por metro Celsius': 'Watt per Meter Celsius',
  'Btu por hora pé Fahrenheit': 'Btu per Hour Foot Fahrenheit',
  'Caloria por segundo centímetro Celsius': 'Calorie per Second Centimeter Celsius',
  'Joule por quilograma Kelvin': 'Joule per Kilogram Kelvin',
  'Joule por quilograma Celsius': 'Joule per Kilogram Celsius',
  'Caloria por grama Celsius': 'Calorie per Gram Celsius',
  'Btu por libra Fahrenheit': 'Btu per Pound Fahrenheit',
  'Joule por metro cúbico': 'Joule per Cubic Meter',
  'Megajoule por metro cúbico': 'Megajoule per Cubic Meter',
  'Btu por pé cúbico': 'Btu per Cubic Foot',
  'Caloria por centímetro cúbico': 'Calorie per Cubic Centimeter',
  'Watt por metro quadrado': 'Watt per Square Meter',
  'Quilowatt por metro quadrado': 'Kilowatt per Square Meter',
  'Btu por hora pé quadrado': 'Btu per Hour Square Foot',
  'Caloria por segundo centímetro quadrado': 'Calorie per Second Square Centimeter',
  'Watt por metro quadrado Kelvin': 'Watt per Square Meter Kelvin',
  'Watt por metro quadrado Celsius': 'Watt per Square Meter Celsius',
  'Btu por hora pé quadrado Fahrenheit': 'Btu per Hour Square Foot Fahrenheit',
  'Caloria por segundo centímetro quadrado Celsius': 'Calorie per Second Square Centimeter Celsius',
  'Metro cúbico por segundo': 'Cubic Meter per Second',
  'Metro cúbico por minuto': 'Cubic Meter per Minute',
  'Metro cúbico por hora': 'Cubic Meter per Hour',
  'Litro por segundo': 'Liter per Second',
  'Litro por minuto': 'Liter per Minute',
  'Litro por hora': 'Liter per Hour',
  'Pé cúbico por segundo': 'Cubic Foot per Second',
  'Pé cúbico por minuto': 'Cubic Foot per Minute',
  'Galão por segundo': 'Gallon per Second',
  'Galão por minuto': 'Gallon per Minute',
  'Galão por hora': 'Gallon per Hour',
  'Quilograma por segundo': 'Kilogram per Second',
  'Quilograma por minuto': 'Kilogram per Minute',
  'Quilograma por hora': 'Kilogram per Hour',
  'Grama por segundo': 'Gram per Second',
  'Grama por minuto': 'Gram per Minute',
  'Grama por hora': 'Gram per Hour',
  'Libra por segundo': 'Pound per Second',
  'Libra por minuto': 'Pound per Minute',
  'Libra por hora': 'Pound per Hour',
  'Tonelada por hora': 'Ton per Hour',
  'Mol por segundo': 'Mole per Second',
  'Mol por minuto': 'Mole per Minute',
  'Mol por hora': 'Mole per Hour',
  'Quilomol por segundo': 'Kilomole per Second',
  'Quilomol por minuto': 'Kilomole per Minute',
  'Quilomol por hora': 'Kilomole per Hour',
  'Quilograma por metro quadrado por segundo': 'Kilogram per Square Meter per Second',
  'Grama por centímetro quadrado por segundo': 'Gram per Square Centimeter per Second',
  'Libra por pé quadrado por segundo': 'Pound per Square Foot per Second',
  'Libra por polegada quadrada por segundo': 'Pound per Square Inch per Second',
  'Mol por litro': 'Mole per Liter',
  'Mol por metro cúbico': 'Mole per Cubic Meter',
  'Milimol por litro': 'Millimole per Liter',
  'Micromol por litro': 'Micromole per Liter',
  'Mol por centímetro cúbico': 'Mole per Cubic Centimeter',
  'Grama por litro': 'Gram per Liter',
  'Miligrama por litro': 'Milligram per Liter',
  'Micrograma por litro': 'Microgram per Liter',
  'Grama por metro cúbico': 'Gram per Cubic Meter',
  'Quilograma por metro cúbico': 'Kilogram per Cubic Meter',
  'Libra por galão': 'Pound per Gallon',
  'Onça por galão': 'Ounce per Gallon',
  'Pascal-segundo': 'Pascal-second',
  'Centipoise': 'Centipoise',
  'Libra por pé-segundo': 'Pound per Foot-second',
  'Libra-força segundo por pé quadrado': 'Pound-force Second per Square Foot',
  'Metro quadrado por segundo': 'Square Meter per Second',
  'Centímetro quadrado por segundo': 'Square Centimeter per Second',
  'Centistokes': 'Centistokes',
  'Pé quadrado por segundo': 'Square Foot per Second',
  'Polegada quadrada por segundo': 'Square Inch per Second',
  'Newton por metro': 'Newton per Meter',
  'Milinewton por metro': 'Millinewton per Meter',
  'Dina por centímetro': 'Dyne per Centimeter',
  'Erg por centímetro quadrado': 'Erg per Square Centimeter',
  'Libra-força por polegada': 'Pound-force per Inch',
  'Metro quadrado': 'Square Meter',
  'Centímetro quadrado': 'Square Centimeter',
  'Darcy': 'Darcy',
  'Milidarcy': 'Millidarcy',
  'Polegada quadrada': 'Square Inch',
  'Pé quadrado': 'Square Foot',
  'Barn': 'Barn',
  'Candela por metro quadrado': 'Candela per Square Meter',
  'Candela por centímetro quadrado': 'Candela per Square Centimeter',
  'Candela por pé quadrado': 'Candela per Square Foot',
  'Candela por polegada quadrada': 'Candela per Square Inch',
  'Foot-lambert': 'Foot-lambert',
  'Lambert': 'Lambert',
  'Nit': 'Nit',
  'Candlepower': 'Candlepower',
  'Lumen por esferorradiano': 'Lumen per Steradian',
  'Pixel por polegada': 'Pixel per Inch',
  'Pixel por centímetro': 'Pixel per Centimeter',
  'Ponto por polegada': 'Point per Inch',
  'Ponto por centímetro': 'Point per Centimeter',
  'Terahertz': 'Terahertz',
  'Microvolt': 'Microvolt',
  'Nanovolt': 'Nanovolt',
  'Megavolt': 'Megavolt',
  'Gigavolt': 'Gigavolt',
  'Abvolt': 'Abvolt',
  'Coulomb por metro': 'Coulomb per Meter',
  'Coulomb por centímetro': 'Coulomb per Centimeter',
  'Coulomb por milímetro': 'Coulomb per Millimeter',
  'Microcoulomb por metro': 'Microcoulomb per Meter',
  'Nanocoulomb por metro': 'Nanocoulomb per Meter',
  'Coulomb por metro quadrado': 'Coulomb per Square Meter',
  'Coulomb por centímetro quadrado': 'Coulomb per Square Centimeter',
  'Coulomb por milímetro quadrado': 'Coulomb per Square Millimeter',
  'Microcoulomb por metro quadrado': 'Microcoulomb per Square Meter',
  'Nanocoulomb por metro quadrado': 'Nanocoulomb per Square Meter',
  'Coulomb por metro cúbico': 'Coulomb per Cubic Meter',
  'Coulomb por centímetro cúbico': 'Coulomb per Cubic Centimeter',
  'Coulomb por milímetro cúbico': 'Coulomb per Cubic Millimeter',
  'Microcoulomb por metro cúbico': 'Microcoulomb per Cubic Meter',
  'Nanocoulomb por metro cúbico': 'Nanocoulomb per Cubic Meter',
  'Ampere por metro': 'Ampere per Meter',
  'Ampere por centímetro': 'Ampere per Centimeter',
  'Ampere por milímetro': 'Ampere per Millimeter',
  'Miliampere por metro': 'Milliampere per Meter',
  'Ampere por metro quadrado': 'Ampere per Square Meter',
  'Ampere por centímetro quadrado': 'Ampere per Square Centimeter',
  'Ampere por milímetro quadrado': 'Ampere per Square Millimeter',
  'Miliampere por metro quadrado': 'Milliampere per Square Meter',
  'Volt por metro': 'Volt per Meter',
  'Volt por centímetro': 'Volt per Centimeter',
  'Volt por milímetro': 'Volt per Millimeter',
  'Quilovolt por metro': 'Kilovolt per Meter',
  'Newton por coulomb': 'Newton per Coulomb',
  'Miliohm': 'Milliohm',
  'Microohm': 'Microohm',
  'Quilo-ohm': 'Kilohm',
  'Megaohm': 'Megaohm',
  'Gigaohm': 'Gigaohm',
  'Ohm metro': 'Ohm Meter',
  'Ohm centímetro': 'Ohm Centimeter',
  'Ohm milímetro': 'Ohm Millimeter',
  'Microohm metro': 'Microohm Meter',
  'Quilo-ohm metro': 'Kilohm Meter',
  'Milisiemens': 'Millisiemens',
  'Microsiemens': 'Microsiemens',
  'Nanosiemens': 'Nanosiemens',
  'Mho': 'Mho',
  'Micromho': 'Micromho',
  'Siemens por metro': 'Siemens per Meter',
  'Siemens por centímetro': 'Siemens per Centimeter',
  'Milisiemens por metro': 'Millisiemens per Meter',
  'Microsiemens por metro': 'Microsiemens per Meter',
  'Mho por metro': 'Mho per Meter',
  'Milifarad': 'Millifarad',
  'Nanofarad': 'Nanofarad',
  'Picofarad': 'Picofarad',
  'Abfarad': 'Abfarad',
  'Microhenry': 'Microhenry',
  'Nanohenry': 'Nanohenry',
  'Picohenry': 'Picohenry',
  'Abhenry': 'Abhenry',
  'Oersted': 'Oersted',
  'Gilbert': 'Gilbert',
  'Ampere por polegada': 'Ampere per Inch',
  'Miliweber': 'Milliweber',
  'Microweber': 'Microweber',
  'Volt-segundo': 'Volt-second',
  'Militela': 'Millitesla',
  'Microtesla': 'Microtesla',
  'Nanotesla': 'Nanotesla',
  'Miligauss': 'Milligauss',
  'Weber por metro quadrado': 'Weber per Square Meter',
  'Rutherford': 'Rutherford',
  'Desintegrações por segundo': 'Disintegrations per Second',
  'Desintegrações por minuto': 'Disintegrations per Minute',
  'Quilobecquerel': 'Kilobecquerel',
  'Megabecquerel': 'Megabecquerel',
  'Gigabecquerel': 'Gigabecquerel',
  'Terabecquerel': 'Terabecquerel',
  'Milicurie': 'Millicurie',
  'Microcurie': 'Microcurie',
  'Nanocurie': 'Nanocurie',
  'Miliroentgen': 'Milliroentgen',
  'Microroentgen': 'Microroentgen',
  'Coulomb por quilograma': 'Coulomb per Kilogram',
  'Milicoulomb por quilograma': 'Millicoulomb per Kilogram',
  'Miligray': 'Milligray',
  'Microgray': 'Microgray',
  'Milirad': 'Millirad',
  'Joule por quilograma': 'Joule per Kilogram',
  'Bit/segundo': 'Bit/second',
  'Kilobit/segundo': 'Kilobit/second',
  'Megabit/segundo': 'Megabit/second',
  'Gigabit/segundo': 'Gigabit/second',
  'Em': 'Em',
  'Rem': 'Rem',

  // Consumo de Combustível / Medidas Culinárias / Ritmo de Corrida
  'Quilômetro por Litro': 'Kilometer per Liter',
  'Litro por 100 Quilômetros': 'Liter per 100 Kilometers',
  'Milhas por Galão (EUA)': 'Miles per Gallon (US)',
  'Milhas por Galão (Reino Unido)': 'Miles per Gallon (UK)',
  'Xícara': 'Cup',
  'Colher de Sopa': 'Tablespoon',
  'Colher de Chá': 'Teaspoon',
  'Onça Fluída (EUA)': 'Fluid Ounce (US)',
  'Minuto por Quilômetro': 'Minute per Kilometer',
  'Minuto por Milha': 'Minute per Mile',
  'Quilômetro por Hora': 'Kilometer per Hour',
  'Milha por Hora': 'Mile per Hour',

  // PPM / Concentration
  'Partes por Milhão': 'Parts per Million',
  'Partes por Bilhão': 'Parts per Billion',
  'Partes por Trilhão': 'Parts per Trillion',
  'Por Cento': 'Percent',
  'Permilagem': 'Permille',

  // dBm / Power
  'Decibel-miliwatt': 'Decibel-milliwatt',
  'Miliwatt': 'Milliwatt',

  // Scale
  'Escala 1:1 (Real)': 'Scale 1:1 (Real)',
  'Escala 1:2': 'Scale 1:2',
  'Escala 1:5': 'Scale 1:5',
  'Escala 1:10': 'Scale 1:10',
  'Escala 1:20': 'Scale 1:20',
  'Escala 1:50': 'Scale 1:50',
  'Escala 1:100': 'Scale 1:100',
  'Escala 1:200': 'Scale 1:200',
  'Escala 1:500': 'Scale 1:500',
  'Escala 1:1000': 'Scale 1:1000',

  // Large Numbers
  'Milhar': 'Thousand',
  'Milhão': 'Million',
  'Bilhão': 'Billion',
  'Trilhão': 'Trillion',
  'Quadrilhão': 'Quadrillion',
  'Quintilhão': 'Quintillion',

  // Cup to Grams by Ingredient
  'Xícara de Farinha de Trigo': 'Cup of Wheat Flour',
  'Grama de Farinha de Trigo': 'Gram of Wheat Flour',
  'Xícara de Açúcar': 'Cup of Sugar',
  'Grama de Açúcar': 'Gram of Sugar',
  'Xícara de Manteiga': 'Cup of Butter',
  'Grama de Manteiga': 'Gram of Butter',

  // Number Bases
  'Binário': 'Binary',
  'Octal': 'Octal',
  'Hexadecimal': 'Hexadecimal',

  // Pixels / DPI
  'Pixels (72 DPI)': 'Pixels (72 DPI)',
  'Polegadas (72 DPI)': 'Inches (72 DPI)',
  'Centímetros (72 DPI)': 'Centimeters (72 DPI)',
  'Pixels (96 DPI)': 'Pixels (96 DPI)',
  'Polegadas (96 DPI)': 'Inches (96 DPI)',
  'Centímetros (96 DPI)': 'Centimeters (96 DPI)',
  'Pixels (150 DPI)': 'Pixels (150 DPI)',
  'Polegadas (150 DPI)': 'Inches (150 DPI)',
  'Centímetros (150 DPI)': 'Centimeters (150 DPI)',
  'Pixels (300 DPI)': 'Pixels (300 DPI)',
  'Polegadas (300 DPI)': 'Inches (300 DPI)',
  'Centímetros (300 DPI)': 'Centimeters (300 DPI)',
  'Pixels (600 DPI)': 'Pixels (600 DPI)',
  'Polegadas (600 DPI)': 'Inches (600 DPI)',
  'Centímetros (600 DPI)': 'Centimeters (600 DPI)',

  // Inch Fraction
  'Polegada (Fração)': 'Inch (Fraction)',
  'Polegada (Decimal)': 'Inch (Decimal)'
};

const CONV_DESC_EN = {
  'length': 'Convert length and distance units.',
  'temperature': 'Convert temperature units.',
  'weight': 'Convert weight and mass units.',
  'volume': 'Convert volume and capacity units.',
  'area': 'Convert area and surface units.',
  'time': 'Convert time units.',
  'speed': 'Convert speed and velocity units.',
  'shoe-size': 'Convert shoe sizes across different regions.',
  'density': 'Convert density units.',
  'vel_angular': 'Convert angular velocity units.',
  'aceleracao': 'Convert acceleration units.',
  'aceleracao-angular': 'Convert angular acceleration units.',
  'volume-especifico': 'Convert specific volume units.',
  'momento-inercia': 'Convert moment of inertia units.',
  'torque': 'Convert torque units.',
  'pressure': 'Convert pressure units.',
  'energy': 'Convert energy and work units.',
  'fuel-efficiency-mass': 'Convert fuel efficiency (mass) units.',
  'fuel-efficiency-volume': 'Convert fuel efficiency (volume) units.',
  'temperature-interval': 'Convert temperature interval units.',
  'thermal-expansion': 'Convert thermal expansion units.',
  'thermal-resistance': 'Convert thermal resistance units.',
  'thermal-conductivity': 'Convert thermal conductivity units.',
  'specific-heat-capacity': 'Convert specific heat capacity units.',
  'thermal-energy-density': 'Convert thermal energy density units.',
  'heat-flux-density': 'Convert heat flux density units.',
  'heat-transfer-coefficient': 'Convert heat transfer coefficient units.',
  'volumetric-flow-rate': 'Convert volumetric flow rate units.',
  'mass-flow-rate': 'Convert mass flow rate units.',
  'molar-flow-rate': 'Convert molar flow rate units.',
  'mass-flux-density': 'Convert mass flux density units.',
  'molar-concentration': 'Convert molar concentration units.',
  'solution-concentration': 'Convert solution concentration units.',
  'dynamic-viscosity': 'Convert dynamic viscosity units.',
  'kinematic-viscosity': 'Convert kinematic viscosity units.',
  'surface-tension': 'Convert surface tension units.',
  'permeability': 'Convert permeability units.',
  'luminance': 'Convert luminance units.',
  'luminous-intensity': 'Convert luminous intensity units.',
  'illumination': 'Convert illumination units.',
  'digital-image-resolution': 'Convert digital image resolution units.',
  'frequency-wavelength': 'Convert frequency and wavelength units.',
  'charge': 'Convert electric charge units.',
  'current': 'Convert electric current units.',
  'voltage': 'Convert electric voltage units.',
  'linear-charge-density': 'Convert linear charge density units.',
  'surface-charge-density': 'Convert surface charge density units.',
  'volume-charge-density': 'Convert volume charge density units.',
  'linear-current-density': 'Convert linear current density units.',
  'surface-current-density': 'Convert surface current density units.',
  'electric-field-strength': 'Convert electric field strength units.',
  'electrical-resistance': 'Convert electrical resistance units.',
  'electrical-resistivity': 'Convert electrical resistivity units.',
  'electrical-conductance': 'Convert electrical conductance units.',
  'electrical-conductivity': 'Convert electrical conductivity units.',
  'electrostatic-capacitance': 'Convert electrostatic capacitance units.',
  'inductance': 'Convert inductance units.',
  'magnetomotive-force': 'Convert magnetomotive force units.',
  'magnetic-field-intensity': 'Convert magnetic field intensity units.',
  'magnetic-flux': 'Convert magnetic flux units.',
  'magnetic-flux-density': 'Convert magnetic flux density units.',
  'radiacao': 'Convert radiation units.',
  'atividade-radiacao': 'Convert radiation activity units.',
  'exposicao-radiacao': 'Convert radiation exposure units.',
  'dose-absorvida': 'Convert absorbed dose units.',
  'data_storage': 'Convert digital data storage units.',
  'data_transfer': 'Convert data transfer rate units.',
  'typography': 'Convert typography units.',
  'angulo': 'Convert angle units like degrees, radians and gradians.',
  'potencia': 'Convert power units like watts, metric horsepower and horsepower.',
  'forca': 'Convert force units like newton, kilogram-force and pound-force.',
  'frequencia': 'Convert frequency units like hertz, kilohertz and revolutions per minute.',
  'nivel-som': 'Convert sound level units like decibel, bel and neper.',
  'tamanho-camiseta': 'Convert t-shirt sizes between Brazil, the United States and Europe.',
  'tamanho-calca': 'Convert pants sizes between Brazil, the United States and Europe.',
  'tamanho-tenis': 'Convert sneaker sizes between Brazil, the US, Europe, the UK and Japan.',
  'consumo-combustivel': 'Convert fuel consumption between km/l, L/100km, US mpg and UK mpg.',
  'culinaria': 'Convert cooking measurements like cups, tablespoons, teaspoons and fluid ounces.',
  'ritmo': 'Convert running pace between min/km, min/mi, km/h and mph.',
  'ppm': 'Convert between ppm, ppb, ppt, percent and permille.',
  'potencia-dbm': 'Convert power between dBm, watt, milliwatt and kilowatt.',
  'escala': 'Convert real dimensions to scale for architecture, models and maps.',
  'numeros-grandes': 'Convert between thousand, million, billion, trillion and quadrillion.',
  'culinaria-gramas': 'Convert cups to grams by ingredient (flour, sugar, butter).',
  'bases-numericas': 'Convert between binary, octal, decimal and hexadecimal.',
  'pixels-dpi': 'Convert pixels to inches and centimeters by DPI (72, 96, 150, 300, 600).',
  'fracao-polegada': 'Convert inch fractions to decimal and millimeters.',
  'cores': 'Convert colors between HEX, RGB, HSL and CMYK.',
  'fuso-horario': 'Convert date and time between world capitals with daylight-saving rules.'
};

export function getTranslatedCategories(dict, lang = 'pt') {
  if (lang === 'pt' || !dict) return categories;
  
  return categories.map(cat => {
    const categoryKey = CATEGORY_MAP[cat.id];
    const translatedCatName = (dict.categories && categoryKey && dict.categories[categoryKey]) || cat.name;
    
    return {
      ...cat,
      name: translatedCatName,
      converters: cat.converters.map(conv => {
        const convKey = CONVERTER_MAP[conv.id];
        let translatedConvName = conv.name;
        
        if (convKey) {
          if (dict.units && dict.units[convKey]) {
            translatedConvName = dict.units[convKey];
          } else if (dict.home && dict.home.converters && dict.home.converters[convKey]) {
            translatedConvName = dict.home.converters[convKey];
          }
        }
        
        return {
          ...conv,
          name: translatedConvName,
          description: CONV_DESC_EN[conv.id] ?? conv.description,
          units: conv.units ? conv.units.map(unit => ({
            ...unit,
            name: UNIT_EN[unit.name] || unit.name
          })) : []
        };
      })
    };
  });
}